import React from 'react';
import { useTranslation } from 'react-i18next';
import { Operation } from '../../../services/types/Operation';
import { customDateStr } from '../../../shared/misc/utils';
import GeneralInfoItem from './GeneralInfoItem';

interface Props {
  operation: Operation;
}

const GIFinantialData: React.FC<Props> = ({ operation }) => {
  const { t } = useTranslation();
  const dollarESLocale = Intl.NumberFormat('es');
  return (
    <div className="gi-items table-responsive">
      <GeneralInfoItem title={t('lendingType_type_modality')}>
        {`${operation.lendingType} / `}
        {`${operation.type}${operation.modality ? ` / ${operation.modality}` : ''}`}
      </GeneralInfoItem>
      <GeneralInfoItem title={t('idbAmount')}>
        {operation.idbAmount && `$ ${dollarESLocale.format(operation.idbAmount)}`}
      </GeneralInfoItem>
      <GeneralInfoItem title={t('totalProjectCost')}>
        {operation.totalProjectCost && `$ ${dollarESLocale.format(operation.totalProjectCost)}`}
      </GeneralInfoItem>
      <GeneralInfoItem title={t('percDisburstment')}>{operation.disbursed}</GeneralInfoItem>
      <GeneralInfoItem title={t('lastDisburstmentDate')}>
        {customDateStr(operation.lastDisbursmentDate)}
      </GeneralInfoItem>
      <GeneralInfoItem title={t('reformulated')}>{operation.isReformulated}</GeneralInfoItem>
      <GeneralInfoItem title={t('CoFinancing')}>{operation.coFinancing}</GeneralInfoItem>
    </div>
  );
};

export default GIFinantialData;
